export default "__VITE_ASSET__DqUcBpFL__"